import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportCarburetionFilters, getReportCarburetionAction } from "redux/actions/Reports/reportCarburetion/reportCarburetionActions";

export const ReportCarburetionView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportCarburetion }) => reportCarburetion);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportCarburetionAction({ startDate, endDate, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportCarburetionAction({ startDate, endDate, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte de Carburación" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingReportCarburetion ? <LoadingComponent /> :
        <TableInputs
          reducer="reportCarburetion"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportCarburetionFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
